import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/product/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveProduct: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/product/edit/save", vo, successCallback, failureCallback);
    },
    upload: (file, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "Products");
        formData.append("field", "Cover");
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    },
};

export default EditService;
